import { has, pickBy } from 'lodash'
import listingStatus from '@/lib/mapping/listing-status'
import { buyNowStatus } from '@/lib/mapping'

// These are the "Other" search filters at the bottom of the sidebar
const getAdditionalFacets = (commodity, searchIs, includeAutomaticSidebarPositionFacets = true) => {
  let hasMaternalLabels = has(commodity, 'listing.maternalLabels')

  let additionalFacets = {}

  // Each commodity has different labels for pregnant / children
  if (hasMaternalLabels) {
    additionalFacets['meta.pregnant'] = {
      label: commodity.listing.maternalLabels.pregnant,
      facetKey: 'meta.pregnant',
      onValue: true,
      active: searchIs.livestock
    }

    additionalFacets['meta.children'] = {
      label: commodity.listing.maternalLabels.children,
      facetKey: 'meta.children',
      onValue: true,
      active: searchIs.livestock
    }
  }

  // NOTE: additionalFacets key must match facetKey

  additionalFacets['meta.pedigreeStatus'] = {
    label: 'Pedigree',
    facetKey: 'meta.pedigreeStatus',
    onValue: 'R',
    active: searchIs.livestock
  }

  additionalFacets['meta.tbRestricted'] = {
    label: 'TB Restricted',
    facetKey: 'meta.tbRestricted',
    onValue: true,
    active: searchIs.livestock && searchIs.cattle,
    hideFromAutomaticSidebarPosition: true
  }

  additionalFacets['meta.premiumHealthScheme'] = {
    label: 'Premium Health Scheme',
    facetKey: 'meta.premiumHealthScheme',
    onValue: '1',
    active: searchIs.livestock,
    hideFromAutomaticSidebarPosition: true
  }

  additionalFacets['meta.health.Maedi Visna.accredited'] = {
    label: 'MV Accredited',
    facetKey: 'meta.health.Maedi Visna.accredited',
    onValue: true,
    active: searchIs.livestock && searchIs.sheep,
    hideFromAutomaticSidebarPosition: true
  }

  additionalFacets['meta.health.Scrapie.accredited'] = {
    label: 'Scrapie Monitored',
    facetKey: 'meta.health.Scrapie.accredited',
    onValue: true,
    active: searchIs.livestock && searchIs.sheep,
    hideFromAutomaticSidebarPosition: true
  }

  additionalFacets['meta.cross'] = {
    label: 'Purebred',
    facetKey: 'meta.cross',
    onValue: false,
    active: searchIs.livestock
  }

  additionalFacets['meta.homebred'] = {
    label: 'Homebred',
    facetKey: 'meta.homebred',
    onValue: false,
    active: searchIs.livestock
  }

  additionalFacets['meta.farmAssured'] = {
    label: 'Farm Assured',
    facetKey: 'meta.farmAssured',
    onValue: true,
    active: searchIs.livestock || searchIs.feedBedding
  }

  additionalFacets['meta.organicAssured'] = {
    label: 'Organic Assured',
    facetKey: 'meta.organicAssured',
    onValue: true,
    active: searchIs.livestock || searchIs.feedBedding
  }

  additionalFacets['tradeType'] = {
    label: 'Wanted',
    facetKey: 'tradeType',
    onValue: 'Wanted',
    hideFromAutomaticSidebarPosition: true,
    active: true
  }

  additionalFacets['status'] = {
    label: 'Hide Sold',
    facetKey: 'status',
    onValue: listingStatus.LIVE,
    hideFromAutomaticSidebarPosition: true,
    active: true
  }

  additionalFacets['meta.saleDate'] = {
    label: 'Hide Auctions',
    facetKey: 'meta.saleDate',
    onValue: false,
    hideFromAutomaticSidebarPosition: true,
    active: searchIs.livestock
  }

  additionalFacets['meta.buyNow'] = {
    label: 'Buy Now',
    facetKey: 'meta.buyNow',
    onValue: buyNowStatus.ENABLED,
    hideFromAutomaticSidebarPosition: true,
    active: searchIs.cattle
  }

  let filteredFacets = pickBy(additionalFacets, facet => facet.active)

  if (!includeAutomaticSidebarPositionFacets) {
    filteredFacets = pickBy(filteredFacets, facet => !facet.hideFromAutomaticSidebarPosition)
  }

  return filteredFacets
}

export default getAdditionalFacets
